import { Grid, Typography } from "@mui/material";
import React from "react";
import DropDown from "../../../../../../../Components/DropDown/DropDown";
import MuiInputField from "../../../../../../../Components/InputField/InputField";

function Treatments() {
  return (
    <Grid item lg={12} marginY={"30px"}>
      <Typography
        sx={{
          fontWeight: "600",
          fontSize: "14px",

          paddingBottom: "7px",
        }}
      >
        Treatments
      </Typography>

      <Grid container item lg={12} marginY={"30px"}>
        <Grid item lg={3.8}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Select Treatment
          </Typography>
          <DropDown
            placeHolder={"Select Treatment"}
            viewHeight={"44px"}
            borderRadius={"5px"}
            bgColor="white"
            border="2px solid #e9eff7"
            viewWidth="100%"
          />
        </Grid>
        <Grid item lg={1.5} marginX={"30px"}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Add Price
          </Typography>
          <MuiInputField type="number" placeHolder={"Add Price"} />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Treatments;
